import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import EditContentPageIndex from "../../../../components/SidetabPages/Configuration/ContentPage/EditContentPageIndex";

const EditContentPage = () => {
  return (
    <>
      <AnnouncementBar />
      <EditContentPageIndex />
    </>
  );
};
export default EditContentPage;
